import { TextField } from '@chatsdet/ui';
import { EnvironmentStageSelect } from './EnvironmentStageSelect';

export type DefaultEnvironmentValue = {
  /** The kind chosen from the dropdown — 'production', 'staging', 'dev', or any
   * org-defined custom value. When the user picks "Custom" this holds the
   * free-text name they typed. */
  name: string;
  url: string;
};

type Props = {
  value: DefaultEnvironmentValue;
  onChange: (next: DefaultEnvironmentValue) => void;
  /** MCP-server application: the environment URL is the MCP endpoint itself. */
  isMcp?: boolean;
};

export function DefaultEnvironmentStep({ value, onChange, isMcp }: Props) {
  const handleUrlChange = (v: string) => {
    onChange({ ...value, url: v });
  };

  return (
    <div className="space-y-4">
      <EnvironmentStageSelect
        stageId={null}
        stageName={value.name}
        onChange={(stage) => onChange({ ...value, name: stage.name })}
      />

      <TextField
        label={isMcp ? 'MCP endpoint URL' : 'URL'}
        value={value.url}
        onChange={handleUrlChange}
        placeholder={isMcp ? 'https://mcp.example.com/mcp' : 'https://staging.example.com'}
        description={
          isMcp ? 'The MCP server endpoint this environment sends requests to.' : undefined
        }
        isRequired
      />
    </div>
  );
}
